<div class="container" [ngStyle]="{'width': width}">
  <div [ngStyle]="{'flex-basis':percentFilledText, 'background-color':fillColor}"></div>
  <div class="unknown" [ngStyle]="{'flex-basis':percentBlankText}"></div>
  <div class="text">{{description}}</div>
</div>